import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleNext } from './RecruiterIntentActions';
import SessionContext from '../../../../library/Core/SessionContext';
import { getMenuType } from '../../../../library/Core/SmartFunctions';
import RecruiterIntentLayout from './RecruiterIntentLayout';

const RecruiterIntentInfo = () => {
    const { globalState } = useContext(GlobalContext);
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    const { formConfig, data, routeInfo } = useLoaderData() as State;

    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    const [menuType, setMenuType] = useState(getMenuType(data));

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { NEXT: handleNext, ROUTER_NAVIGATE: navigate, REDIRECT: setRedirectUrl, SET_MENU_TYPE: setMenuType },
    } as any);

    useEffect(() => {
        data['recruiterInfo'] = data['recruiterInfo'] || {};
        const domainMap = new Map([...globalState.domain])
        const domain = addUserSpecificDomains(new Map([...domainMap]), data);
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    useEffect(() => {
        let sessionData = { ...sessionState }
        sessionData.menuType = menuType;
        sessionDispatch({ type: 'SET', payload: sessionData });
    }, [menuType]);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <RecruiterIntentLayout>{!state.flags.isDataLoading && <PageBuilder />}</RecruiterIntentLayout>
        </SmartContext.Provider>
    );
};

export default RecruiterIntentInfo;
